import { render } from "./DocumentWrapper.vue?vue&type=template&id=b2237146"
import script from "./DocumentWrapper.vue?vue&type=script&lang=js"
export * from "./DocumentWrapper.vue?vue&type=script&lang=js"

import "./DocumentWrapper.vue?vue&type=style&index=0&id=b2237146&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__